import {useEffect, useState} from "react";
import {PortableText} from "@portabletext/react";
import {RichTextComponents} from "@/components/RichTextComponents";
import Image from "next/image";

export interface ReviewCardProps {
    image?: string;
    name?: string;
    review?: any;
}

export default function ReviewCard({ image, name, review }: ReviewCardProps) {
    function truncateText(blocks: any[], maxLength: number) {
        let currentLength = 0;
        let truncatedBlocks: any[] = [];

        for (let block of blocks) {
            const blockText = block.children.map((child: any) => child.text).join(" ");
            const newLength = currentLength + blockText.length;

            if (newLength > maxLength) {
                const remainingChars = maxLength - currentLength;
                const truncatedText = blockText.slice(0, remainingChars);

                truncatedBlocks.push({
                    ...block,
                    children: [{ ...block.children[0], text: truncatedText + "..." }]
                });
                break;
            } else {
                currentLength = newLength;
                truncatedBlocks.push(block);
            }
        }

        return truncatedBlocks;
    }

    const [maxLength, setMaxLength] = useState(150);

    useEffect(() => {
        const updateMaxLength = () => {
            if (window.innerWidth <= 768) {
                setMaxLength(150); // Limite per mobile
            } else {
                setMaxLength(170); // Limite per desktop
            }
        };

        // Imposta il limite iniziale
        updateMaxLength();

        // Aggiunge un listener per cambiare il limite quando la finestra viene ridimensionata
        window.addEventListener("resize", updateMaxLength);

        // Pulisce l'event listener quando il componente viene smontato
        return () => window.removeEventListener("resize", updateMaxLength);
    }, []);

    return (
        <div className="h-80 bg-white rounded-lg shadow-card p-4">
            <div className="max-h-max justify-between items-center gap-y-5 flex flex-col">
                <div className="flex flex-col justify-center items-center">
                    <Image
                        className="rounded-full h-[80px] w-[80px] object-cover"
                        src={image || ""}
                        alt={name || "Review image"}
                        width={80}
                        height={80}
                    />
                    <p className="text-3xl">{name}</p>
                </div>
                <div>
                    {/* Mostra il contenuto in forma ridotta o intera in base alla dimensione dello schermo */}
                    <div className="p-2 mx-auto text-center">
                        <PortableText
                            value={truncateText(review, maxLength)}  // Tronca il testo a 150 caratteri
                            components={RichTextComponents}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
